/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_CustomInputs */



/**
* | output |
* | --- |
* | "Custom Region" |
*
* @param {Ocr_Crop_CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_custom = /** @type {((inputs?: Ocr_Crop_CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Région personnalisée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefinierte Region")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regione personalizzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользовательский регион")
	if (locale === "es") return /** @type {LocalizedString} */ ("Región personalizada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义区域")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタムリージョン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम क्षेत्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Região personalizada")
	return /** @type {LocalizedString} */ ("Custom Region")
});